import * as React from "react";
import lb4Provider from "../react-admin-lb4";

import { Admin, Resource } from "react-admin";
import {
  RapportsList,
  RapportsEdit,
  RapportsShow,
} from "./DataElements/Rapports";
import { UsersList, UsersEdit, UsersShow } from "./DataElements/Users";
import { BlogsList, BlogsEdit, BlogsShow } from "./DataElements/Blogs";
import { LogsList, LogsEdit, LogsShow } from "./DataElements/Logs";
import {
  DemosRequestsList,
  DemosRequestsEdit,
  DemosRequestsShow,
} from "./DataElements/DemosRequests";

import { FirebaseAuthProvider } from "react-admin-firebase";

import CustomLoginPage from "./CustomLoginPage";
import { firebaseConfig as config } from "../config/FIREBASE_CONFIG";
import firebase from "../config/firebase";

console.log(firebase.auth);

const options = {};
const authProvider = FirebaseAuthProvider(config, options);

const myAuthProvider = {
  ...authProvider,
  login: async (params) => {
    const user = await authProvider.login(params);
    const claims = await authProvider.getPermissions();
    const isAdmin = claims.admin === true;
    console.log(claims);
    if (isAdmin) {
      user.user.getIdToken().then(function (token) {
        console.log(token);
        localStorage.setItem("auth", token);
      });
      return user;
    }
    await authProvider.logout();
    throw new Error("Login error, invalid permissions");
  },
};

class DataWebsite extends React.Component {
  render() {
    // console.log(config);
    return (
      <Admin
        loginPage={CustomLoginPage}
        // dataProvider={lb4Provider("https://apiadmin.agenz.ma")}

        dataProvider={lb4Provider("https://admin.valuation.agenz.ma/valuation")} 
        // dataProvider={lb4Provider("http://127.0.0.1:4000/valuation")}
        authProvider={myAuthProvider}

      >
        <Resource
          name="rapports"
          list={RapportsList}
          show={RapportsShow}
          edit={RapportsEdit}
        />
        <Resource
          name="users"
          list={UsersList}
          show={UsersShow}
          edit={UsersEdit}
        />
        <Resource
          name="blogs"
          list={BlogsList}
          show={BlogsShow}
          edit={BlogsEdit}
        />
        <Resource name="logs"
          list={LogsList}
          show={LogsShow}
          edit={LogsEdit} />
        <Resource
          name="demos-requests"
          list={DemosRequestsList}
          show={DemosRequestsShow}
          edit={DemosRequestsEdit}
        />
      </Admin>
    );
  }
}

export default DataWebsite;
